import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpService } from './http.service';
import { HttpParams } from '@angular/common/http';
import { UserService } from './user.service';

@Injectable()
export class OrderService {

    private url: string = environment.base_url;

    constructor(
        private httpService: HttpService,
        private userService: UserService
    ) {
    }

    getOrder(orderId: number, includes = '') {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/orders/' + orderId + '?include=' + includes, httpParams).map(resp => resp);
    }

    getOrders(httpParams: HttpParams = new HttpParams()) {
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/orders/search', httpParams).map(resp => resp);
    }

    getInbox(httpParams: HttpParams = new HttpParams()) {
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/authorisation_inbox', httpParams).map(resp => resp);
    }

    getPendingRequestsForOrder(httpParams: HttpParams = new HttpParams()) {
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/authorisation_inbox/approved', httpParams).map(resp => resp);
    }

    approveRequisition(requisitionIds: string, notes: any) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        const payload = {
            notes : notes
        };
        return this.httpService.post(this.url + '/b2b/authorisation_inbox/approve/' + requisitionIds, payload, httpParams).map(resp => resp);
    }

    declineRequisition(requisitionIds: string, notes: any) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        const payload = {
            notes : notes
        };
        return this.httpService.post(this.url + '/b2b/authorisation_inbox/decline/' + requisitionIds, payload, httpParams).map(resp => resp);
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/order.service.ts